import {fragments} from '@/gql';
import gql from 'graphql-tag';
export default gql`
  query Film($id: ID!) {
    FilmToCallsheets: Film(id: $id) {
      id
      FilmMasters {
        Callsheets {
          CallsheetAnalyses(countRows:"id") {
            countRows
          }
          ...callsheetDetail
          CallsheetAnalysisProgress {
            ...callsheetAnalysisProgressDetail
          }
        }
      }
    }
  }
  ${fragments.callsheetDetail}
  ${fragments.artworkDetails}
  ${fragments.callsheetAnalysisProgressDetail}
  ${fragments.artworkArtifact}
`;
